import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Link, TextField, Typography } from '@one-thd/sui-atomic-components';
import { EPCContext } from '../../contexts/epcContext';
import { formatPhone } from '../PhoneFieldFormatter/PhoneFieldFormatter';
import { addAnalyticEvent } from '../../analytics/common';
import { linkToPrivacyPage } from '../../analytics/outboundLinks';
import { SECURITY_PATH, ADDRESS_PATH, PRIVACY_PATH } from '../../constants/constants';

export const TooltipContent = () => {

  const handleClick = () => {
    addAnalyticEvent(linkToPrivacyPage);
  };

  return (
    <div>
      <Typography variant="body-base" data-testid="tooltip-content">
        Note you may experience some delays in your request if you have recently
        submitted a request to exercise your privacy rights.
        Please allow sufficient time for your request to be processed.
      </Typography>
    </div>
  );
};

export function ManageAndModify({ isSearchedInitiated, setToggleNewSearch }) {

  const {
    phone, email
  } = useContext(EPCContext);

  const handleNewSearch = () => {
    setToggleNewSearch(true);
  };

  const handleClick = () => {
    addAnalyticEvent(linkToPrivacyPage);
  };

  return (
    <div className="sui-grid sui-gap-4">
      <Typography variant="h2" weight="display">
        MANAGE YOUR PREFERENCES
      </Typography>
      <Typography variant="body-base" weight="regular">
        You can view and manage your marketing and survey preferences to receive savings and
        project ideas, help us improve our services and products, or to opt out of these
        communications. Use this page to tell us how you&apos;d like to receive these communications.
        These preferences will not affect communications such as: account statements, online
        order details, customer service inquires, etc. The preferences that you have entered
        will be honored in accordance with our
        <Link
          weight="regular"
          underline="always"
          href={PRIVACY_PATH}
          onClick={handleClick}
        >
          &nbsp;Privacy and Security Statement
        </Link>.
        <br />
        <br />
        You can update your email and phone number in the&nbsp;
        <Link underline="always" href={SECURITY_PATH}>Security & Password</Link>
        &nbsp;section, and your mailing address in the&nbsp;
        <Link underline="always" href={ADDRESS_PATH}>Addresses</Link>
        &nbsp;section by logging in to your account.
      </Typography>

      {isSearchedInitiated && (
        <div className="sui-grid sui-gap-4">
          <Typography variant="h2" weight="display">Your Personal Information</Typography>
          <div className="sui-grid sui-grid-cols-12 sui-gap-4">
            <div className="sui-col-span-12 sm:sui-col-span-10 md:sui-col-span-8 lg:sui-col-span-6 sui-grid sui-gap-4">
              {email && (
                <TextField
                  id="manage-email"
                  type="text"
                  label="Email Address"
                  value={email}
                  fullWidth
                  disabled
                />
              )}
              {phone && (
                <TextField
                  id="manage-phone"
                  type="text"
                  label="Phone Number"
                  value={formatPhone(phone)}
                  fullWidth
                  disabled
                />
              )}
            </div>
          </div>
          <div className="sui-grid sui-grid-cols-12">
            <div className="sui-col-span-12 sm:sui-col-span-10 md:sui-col-span-8 lg:sui-col-span-4 sui-grid sui-gap-4">
              <Button fullWidth variant="secondary" onClick={handleNewSearch}>New Search</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

ManageAndModify.propTypes = {
  isSearchedInitiated: PropTypes.bool.isRequired,
  setToggleNewSearch: PropTypes.func.isRequired,
};
